module.exports = __webpack_public_path__ + "static/media/call.587d0e34.svg";